import React from "react";
import { useNavigate } from "react-router-dom";

import { Frown } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white px-4">
      <div className="text-center">
        <Frown className="h-16 w-16 text-sky-500 mb-4" />
        <h1 className="text-4xl font-bold mb-2">404 - Page Not Found</h1>
        <p className="text-gray-400 mb-6">
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        <button
          onClick={handleGoBack}
          className="bg-sky-500 hover:bg-sky-600 text-white px-6 py-2 rounded-lg"
        >
          Go Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
